import styled from 'styled-components';

import Checkbox from 'components/Form/Checkbox';
import Input from 'components/Form/Input';
import RichText from 'components/RichText';

import { PageContainer } from 'styles/global';
import BREAKPOINTS from 'styles/breakpoints';
import { columns } from 'styles/grid';
import TYPO, { P2, P3 } from 'styles/typography';

export const Container = styled(PageContainer)`
  padding: 100px 0 66px;

  ${BREAKPOINTS.medium`
    padding: 180px 0 108px;
  `}
`;

export const TitleSection = styled.div`
  ${columns(null, 12)}
  margin-bottom: 30px;
  max-width: 460px;
  justify-self: center;

  ${BREAKPOINTS.medium`
    ${columns(null, 6)}
  `}

  ${BREAKPOINTS.large`
    ${columns(2, 5)}
    justify-self: start;
  `}
`;

export const Title = styled(RichText)`
  margin-bottom: 5px;

  * {
    ${TYPO.h4};
  }
`;

export const Paragraph = styled(P3)`
  max-width: 440px;
`;

export const Subtitle = styled(P2)`
  margin-bottom: 9px;
  opacity: 0.5;
`;

export const Form = styled.form`
  ${columns(null, 12)}
  width: 100%;
  max-width: 440px;
  justify-self: center;

  ${BREAKPOINTS.medium`
    ${columns(7, 6)}
  `}

  ${BREAKPOINTS.large`
    ${columns(7, 4)}
    justify-self: start;
  `}
`;

export const CheckboxStyled = styled(Checkbox)`
  margin: 12px 0 28px;
  max-width: 335px;
`;

export const InputDateField = styled(Input)`
  cursor: pointer;
`;
